"use client";

import { Fragment, ReactNode } from "react";
import { Dialog, DialogPanel, Transition, TransitionChild } from "@headlessui/react";
import '../../styles/user-auth-modal.css';

type Props = {
  authModalOpen: boolean;
  closeModal: () => void;
  children: ReactNode;
};

export default function ModalWrapper({
  authModalOpen,
  closeModal,
  children,
}: Props) {
  return (
    <Transition show={authModalOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50 h-full" onClose={closeModal}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/50" />
        </TransitionChild>

        <div className="fixed inset-0 flex items-center justify-center overflow-hidden">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <DialogPanel
              id="auth-dialog-panel"
              className="relative w-fit max-w-full min-h-0 overflow-visible"
            >
              {children}
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
}
